import { gql } from '@apollo/client';

const MEMBERSHIP_PLAN_FIELDS = `
  planId
  merchantId
  name
  description
  durationValue
  durationUnit
  price
  status
  createdAt
  updatedAt
`;

const MEMBERSHIP_FIELDS = `
  membershipId
  userId
  merchantId
  planId
  planName
  durationValue
  durationUnit
  price
  userName
  userPhone
  userEmail
  notes
  startDate
  expiresAt
  cancelledAt
  status
  registeredVia
  createdAt
  updatedAt
`;

const MEMBERSHIP_HISTORY_FIELDS = `
  history {
    id
    action
    planId
    planName
    pricePaid
    previousExpiresAt
    newExpiresAt
    source
    createdAt
  }
`;

export const GET_MEMBERSHIP_PLANS = gql`
  query membershipPlans($includeArchived: Boolean) {
    membershipPlans(includeArchived: $includeArchived) {
      ${MEMBERSHIP_PLAN_FIELDS}
    }
  }
`;

export const GET_MEMBERSHIPS = gql`
  query memberships {
    memberships {
      ${MEMBERSHIP_FIELDS}
    }
  }
`;

export const GET_MEMBERSHIP = gql`
  query membership($userId: String!) {
    membership(userId: $userId) {
      ${MEMBERSHIP_FIELDS}
      ${MEMBERSHIP_HISTORY_FIELDS}
    }
  }
`;

export const CREATE_MEMBERSHIP_PLAN = gql`
  mutation createMembershipPlan($plan: MembershipPlanInput!) {
    createMembershipPlan(plan: $plan) {
      ${MEMBERSHIP_PLAN_FIELDS}
    }
  }
`;

export const UPDATE_MEMBERSHIP_PLAN = gql`
  mutation updateMembershipPlan($planId: String!, $plan: MembershipPlanInput!) {
    updateMembershipPlan(planId: $planId, plan: $plan) {
      ${MEMBERSHIP_PLAN_FIELDS}
    }
  }
`;

export const ARCHIVE_MEMBERSHIP_PLAN = gql`
  mutation archiveMembershipPlan($planId: String!) {
    archiveMembershipPlan(planId: $planId) {
      ${MEMBERSHIP_PLAN_FIELDS}
    }
  }
`;

export const REQUEST_MEMBERSHIP_ACCOUNT_CODE = gql`
  mutation requestMembershipAccountCode($email: String, $phone: String) {
    requestMembershipAccountCode(email: $email, phone: $phone) {
      success
      message
      uid
      codeSent
    }
  }
`;

export const VERIFY_MEMBERSHIP_ACCOUNT_CODE = gql`
  mutation verifyMembershipAccountCode($email: String, $phone: String, $code: String!) {
    verifyMembershipAccountCode(email: $email, phone: $phone, code: $code) {
      success
      message
      uid
      codeSent
    }
  }
`;

export const REGISTER_MEMBERSHIP = gql`
  mutation registerMembership($input: RegisterMembershipInput!) {
    registerMembership(input: $input) {
      ${MEMBERSHIP_FIELDS}
    }
  }
`;

export const RENEW_MEMBERSHIP = gql`
  mutation renewMembership($userId: String!, $planId: String) {
    renewMembership(userId: $userId, planId: $planId) {
      ${MEMBERSHIP_FIELDS}
    }
  }
`;

export const CANCEL_MEMBERSHIP = gql`
  mutation cancelMembership($userId: String!) {
    cancelMembership(userId: $userId) {
      ${MEMBERSHIP_FIELDS}
    }
  }
`;

export const BATCH_REGISTER_MEMBERSHIPS = gql`
  mutation batchRegisterMemberships($planId: String!, $members: [BatchMembershipMemberInput!]!) {
    batchRegisterMemberships(planId: $planId, members: $members) {
      index
      success
      code
      message
      userId
      accountCreated
      membership {
        ${MEMBERSHIP_FIELDS}
      }
    }
  }
`;
